import Swiper from "swiper"
import { Navigation } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import PhotoSwipe from "photoswipe"
import PhotoSwipeLightbox from "photoswipe/lightbox"
import "photoswipe/style.css"

document.addEventListener("DOMContentLoaded", function () {
  let moreViews = document.querySelectorAll(".more-views li")
  moreViews.forEach(function (view) {
    view.addEventListener("click", function () {
      document
        .querySelector("#media-image")
        .setAttribute("src", this.getAttribute("data-src"))
      document.querySelector(".more-views .active").classList.remove("active")
      this.classList.add("active")
    })
  })
})

document
  .getElementById("media-image")
  .addEventListener("touchstart", handleTouchStart, { passive: true })
document
  .getElementById("media-image")
  .addEventListener("touchmove", handleTouchMove, { passive: true })

let xDown = null
let yDown = null

function handleTouchStart(evt) {
  xDown = evt.touches[0].clientX
  yDown = evt.touches[0].clientY
}

function handleTouchMove(evt) {
  if (!xDown || !yDown) {
    return
  }

  let xUp = evt.touches[0].clientX
  let yUp = evt.touches[0].clientY

  let xDiff = xDown - xUp
  let yDiff = yDown - yUp

  if (Math.abs(xDiff) > Math.abs(yDiff)) {
    if (xDiff > 0) {
      imageRight()
    } else {
      imageLeft()
    }
  }

  xDown = null
  yDown = null
}

function imageRight() {
  let thumbnails = document.querySelector(".more-views")
  let currentThumb = thumbnails.querySelector("li.active")

  if (thumbnails.querySelector("li:last-child") === currentThumb) return

  let nextThumb = currentThumb.nextElementSibling
  let nextImage = nextThumb.getAttribute("data-src")

  document.querySelector("#media-image").setAttribute("src", nextImage)
  document.querySelector(".more-views .active").classList.remove("active")
  nextThumb.classList.add("active")
}

function imageLeft() {
  let thumbnails = document.querySelector(".more-views")
  let currentThumb = thumbnails.querySelector("li.active")

  if (thumbnails.querySelector("li:first-child") === currentThumb) return

  let prevThumb = currentThumb.previousElementSibling
  let prevImage = prevThumb.getAttribute("data-src")

  document.querySelector("#media-image").setAttribute("src", prevImage)
  document.querySelector(".more-views .active").classList.remove("active")
  prevThumb.classList.add("active")
}

Swiper.use([Navigation])

const swiper = new Swiper(".swiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
})

function isPhonePortrait() {
  return window.matchMedia("(max-width: 600px) and (orientation: portrait)")
    .matches
}

const lightbox = new PhotoSwipeLightbox({
  gallery: ".swiper-slide",
  children: "a",
  initialZoomLevel: (zoomLevelObject) => {
    if (isPhonePortrait()) {
      return zoomLevelObject.vFill
    } else {
      return zoomLevelObject.fit
    }
  },
  secondaryZoomLevel: (zoomLevelObject) => {
    if (isPhonePortrait()) {
      return zoomLevelObject.fit
    } else {
      return 1
    }
  },
  pswpModule: () => PhotoSwipe,
})
lightbox.init()
